import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import {useTranslation} from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();

    return (
        <>
            <footer id='footer' className="footer width-footer align-self-end">
                <Container fluid>
                    <Row>
                        <Col sm={6}>
                            {new Date().getFullYear()} © Kassan.
                        </Col>
                        <Col sm={6}>
                            <div className="text-sm-end d-none d-sm-block pe-lg-5 footer-text-extra-margin">
                                {t('footer.text')}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </>
    );
};

export default Footer;